<div class="ranking-title">礼物榜</div>
{{if giftTopThree.length>0 }}
    <div class="top-three">
        {{each giftTopThree item}}     
            {{if $index=='1'}}
                <a href="/home.html?userid={{giftTopThree[1].UserID}}" target="_blank">
                    <div class="second">
                        <div class="tdiv seconddiv">
                            <img class="user-avatar" lay-src="{{giftTopThree[1].SmallDataUrl}}">
                            <div class="des">
                                <h4><span>{{$index+1}}</span>{{giftTopThree[1].NickName}}</h4>
                                <h5>{{giftTopThree[1].ShowContent}}</h5>
                            </div>
                        </div>
                    </div>
                </a>
            {{/if}}
            {{if $index=='0'}}
                <a href="/home.html?userid={{giftTopThree[0].UserID}}" target="_blank">
                    <div class="first">
                        <div class="tdiv firstdiv">
                            <img class="user-avatar" lay-src="{{giftTopThree[0].SmallDataUrl}}">
                            <div class="des">
                                <h4><span>{{$index+1}}</span>{{giftTopThree[0].NickName}}</h4>
                                <h5>{{giftTopThree[0].ShowContent}}</h5>
                            </div>
                        </div>
                    </div>
                </a>
            {{/if}}
            {{if $index=='2'}}
                <a href="/home.html?userid={{giftTopThree[2].UserID}}" target="_blank">
                    <div class="third">
                        <div class="tdiv thirddiv">
                            <img class="user-avatar" lay-src="{{giftTopThree[2].SmallDataUrl}}">
                            <div class="des">
                                <h4><span>{{$index+1}}</span>{{giftTopThree[2].NickName}}</h4>
                                <h5>{{giftTopThree[2].ShowContent}}</h5>
                            </div>
                        </div>
                    </div>
                </a>
            {{/if}}

        
        {{/each}}
    </div>
{{/if}}
{{if giftTopTen.length>0}}
    <div class="top-ten">
        {{each giftTopTen item}}
            <div class="top-ten-box">
                <div style="position: relative;margin: 0 10px;" class="clearfix">
                    {{if $index+4 < 10}}
                            <div class="top-ten-left">{{"0"}}{{$index+4}}</div>
                        {{else if $index+4 >=10}}
                            <div class="top-ten-left">{{$index+4}}</div>
                    {{/if}}
                    <div class="top-ten-center">
                        <div class="user-avatar">
                            <a href="/home.html?userid={{item.UserID}}" target="_blank">
                                <img lay-src="{{item.SmallDataUrl}}">
                            </a>
                        </div>
                        <div class="user-msg">
                            <a href="/home.html?userid={{item.UserID}}" target="_blank">
                                <span class="user-nick">{{item.NickName}}</span>
                            </a>
                            {{if item.sex==1}}
                                <span class="malebg">
                                    <i class="iconfont icon-nanxing"></i><label class="">{{item.age}}</label>
                                </span>
                            {{else if item.sex==0}}
                                <span class="femalebg">
                                    <i class="iconfont icon-nvxing"></i><label class="">{{item.age}}</label>
                                </span>
                            {{/if}}
                            <span class="user-competition">{{item.ShowContent}}</span>
                        </div>
                    </div>
                </div>
                
            </div>
        {{/each}}
    </div>
{{/if}}

